var creditcards = require('../creditcards/index');

angular.module('component-payments.validate.number', [])
    .directive('ctPaymentsValidateNumber', paymentsValidateNumberDirective);

function paymentsValidateNumberDirective() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: postLink
    };

    function postLink(scope, element, attrs, NgModelCtrl) {
        var notValidate;

        NgModelCtrl.$validators.invalidNumber = function (modelValue, viewValue) {
            var value = modelValue || viewValue;
     
            return notValidate ? true : creditcards.card.isValid(creditcards.card.parse(value));
        };

        scope.$watch(attrs.ctPaymentsValidateNumber, function (value) {
            notValidate = value;

            NgModelCtrl.$validate();
        })
    }
}

module.exports = 'component-payments.validate.number';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/validators/number.js
 ** module id = 102
 ** module chunks = 1
 **/